(function () {
  'use strict';

  function initFilters(root) {
    if (!root || root.dataset.filtersReady) return;
    root.dataset.filtersReady = 'true';
    var buttons = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('[data-cat]');
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-filter');
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cards.forEach(function (c) { c.hidden = !(f === 'all' || c.getAttribute('data-cat') === f); });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-work]').forEach(initFilters);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
